import { twClassMerge } from '@healthhub/react-ui';
import type { PropsWithChildren } from 'react';


interface MaxWidthContainerProps {
  className?: string;
}

const MaxWidthContainer = ({ children, className }: PropsWithChildren<MaxWidthContainerProps>) => (
  <div className={twClassMerge('max-w-7xl w-full', className)}>{children}</div>
);

export default MaxWidthContainer;
